@if (record._id) {
  <div class="modal fade" id="add-comment-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Comment</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #addCommentForm="ngForm">
            <div class="form-group">
              <textarea class="form-control" rows="5" name="text" [(ngModel)]="commentText" placeholder="Write your comment here..." required></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="addComment(record)"
            [disabled]="!addCommentForm.form.valid">
            <i class="fa fa-plus-circle"></i> Add
          </button>
        </div>
      </div>
    </div>
  </div>
}
